<template>
  <div id="container">
    <section id="mypage">
      <div class="wrap">
        <div class="cts_box">
          <h2 class="sub_ttl"><span>複眼経済塾からの退塾について</span></h2>
          <p class="lead_txt">
            こちらのページでは複眼経済塾からの退塾のお手続きを行います。
          </p>
          <p class="lead_txt">
            退塾ご希望の方は下記のボタンより「問い合わせフォーム」に進んでいただき、「退塾希望」とご連絡ください。<br>
            入塾手続き後8日以内にご連絡いただいた場合は、クーリングオフ期間となり、入塾金を全額返金いたします。
          </p>
          <div class="button_wrap ">
            <input type="button" class="submit arrow large light arrow" value="複眼経済塾を退塾する" @click="membershipWithdrawal">
          </div>
          <br>
          <br>

          <div class="button_wrap">
            <p class="alnC sp_alnL mb10">退塾を希望されない方はこちらのボタンからマイページにお戻りください。</p>
            <router-link :to="{ name: 'UsersCustomerAccount'}" class="submit arrow large light skeleton arrow back">
              マイページに戻る
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import Libraries from '@/components/Libraries'

export default {
  mixins: [Libraries],
  data() {
  },
  mounted() {
    if (this.isUserJoin()) {
      this.$router.push({name: 'UsersCustomerWithdrawal'})
    }
  },
  methods: {
    membershipWithdrawal() {
      this.$router.push({name: 'Contacts', query: {description: '退塾希望'}})
    }
  }
}
</script>
